import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[appPageScrollFetch]',
  standalone: true,
})
export class PageScrollFetchDirective {
  private atBottom = false;
  private performedAction = false;
  private touchStartY = 0;
  private touchEndY = 0;

  @Output() fetchData = new EventEmitter<void>();

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(): void {
    if (this.isNearBottom()) {
      this.atBottom = true;

      this.performedAction = false;
      this.emitEvent();
    } else {
      this.atBottom = false;
    }
  }

  @HostListener('window:wheel', ['$event'])
  onWheel(event: WheelEvent): void {
    if (event.deltaY > 30) {
      this.performedAction = false;

      this.emitEvent();
    }

    if (event.deltaY <= 30) {
      this.performedAction = false;
    }
  }

  @HostListener('touchstart', ['$event'])
  onTouchStart(event: TouchEvent): void {
    this.touchStartY = event.touches[0].clientY;
  }

  @HostListener('touchend', ['$event'])
  onTouchEnd(event: TouchEvent): void {
    this.touchEndY = event.changedTouches[0].clientY;
    if (this.atBottom && this.touchStartY > this.touchEndY) {
      this.fetchData.emit();
    }
  }

  private isNearBottom(): boolean {
    const tolerance = 10;
    const position = window.innerHeight + window.scrollY;
    const height = document.body.offsetHeight;

    return position >= height - tolerance;
  }

  private emitEvent(): void {
    if (this.atBottom && !this.performedAction) {
      this.fetchData.emit();
      this.performedAction = true;
    }
  }
}
